
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7 12.334A5.333 5.333 0 107 1.667a5.333 5.333 0 000 10.667zm0 1.333A6.667 6.667 0 107 .334a6.667 6.667 0 000 13.333zM7.667 3v5.067H6.333V3h1.334zM7 9a1 1 0 100 2 1 1 0 000-2z","fill":"#DA3347"}})])
          )
        }
      }
    